import React from "react";
import { useEpochFormatter } from "src/components/EpochDate/useEpochFormatter";

const EpochDate = ({
  date = null,
  prefix = "",
  postfix = "",
  appendFormat = "",
  formate = "",
  notAppend = false,
}) => {
  const formatEpoch = useEpochFormatter(formate);
  const formatted = formatEpoch(date, appendFormat, notAppend);

  return <span>{`${prefix}${formatted}${postfix}`}</span>;
};

export default EpochDate;
